import { jsx as _jsx } from "react/jsx-runtime";
import "./wdyr";
import "@bluframe/blublocks/blublocks.css";
import { ApolloProvider } from "@apollo/client";
import { BluBlocksProvider, ToastProvider } from "@bluframe/blublocks";
import { theme } from "@bluframe/mightychroma-mightytool-ui";
import graphql from "apolloGraphql";
import { MightyToolProvider } from "contexts/MightyTool";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app";
const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Root element #root not found");
}
const root = createRoot(rootElement);
root.render(_jsx(ApolloProvider, { client: graphql(), children: _jsx(BrowserRouter, { children: _jsx(MightyToolProvider, { children: _jsx(BluBlocksProvider, { theme: theme, children: _jsx(ToastProvider, { children: _jsx(App, {}) }) }) }) }) }));
